import React from 'react';
import { Hero } from '../components/sections/Hero';
import { FossilFillsFeature } from '../components/sections/FossilFillsFeature';
import { HowItWorks } from '../components/sections/HowItWorks';
import ExtensionDownload from '../components/ExtensionDownload';

export const HomePage: React.FC = () => {
  // Determine environment from URL
  const isDev = window.location.hostname.includes('dev.');
  const isStg = window.location.hostname.includes('stg.');
  const environment = isDev ? 'dev' : isStg ? 'stg' : 'prd';

  return (
    <>
      <Hero />
      <FossilFillsFeature />
      <HowItWorks />
      <ExtensionDownload environment={environment} />
      {/* We'll add more sections here: Features, Demo, etc. */}
    </>
  );
};